import { createPortal } from 'react-dom';

const MediaGalleryModalGateway = ({ children, target }) => {
  if (typeof window === 'undefined' || !target) {
    return null;
  }
  return createPortal(children, target);
};

export default MediaGalleryModalGateway;
